/**
 * 11155111 = Sepolia Network
 */
export const network =
  process.env.NEXT_PUBLIC_MANIFOLD_NETWORK === 'prod' ? '1' : '11155111';

export const projectId = process.env.MANIFOLD_PROJECT_ID;

export interface WidgetProps {
  listingId: string;
}
